<template>
	<div class="item">
		<div class="time flex-row-align-center flex-just-between mb-10">
			<div class="DIN pos-rela fz-12 yx-color-text-primary"
				>{{ anchor_info.live_type === '1' ? anchor_info.estimate_time : anchor_info.cooperate_start_time }}
				<div class="pos-abso details-line" v-if="ind + 1 != detail_list.length"></div>
			</div>
			<div class="info ml-8 radius-8 flex-row-align-center flex-just-between cursor-pointer" @click="lookShop">
				<div class="flex-row-align-center">
					<yx-avatar :src="anchor_info.head"></yx-avatar>
					<div class="ml-10">
						<div class="flex flex-align-center" style="width: 86px">
							<div class="flex-row-align-center mr-4" style="width: 16px">
								<platform-icon :platformId="anchor_info.platform_id"></platform-icon>
							</div>
							<rd-text class="fz-12 yx-pingfang">{{ anchor_info.anchor_name }}</rd-text>
						</div>
						<div class="title-bottom fz-12 flex flex-align-center yx-color-text-secondary mt-4">
							<span>{{ product_list.length }} 件开播商品</span>
							<i class="iconfont icon-a-rightxiangyoujiantou right-icon"></i>
						</div>
					</div>
				</div>
				<rd-status class="ml-10" :statusType="anchor_info.live_type === '2' ? '' : 'warning'"></rd-status>
				<div class="font-h6-regular color-gy-8">{{ anchor_info.live_type === '2' ? '已开播' : '未开播' }}</div>
			</div>
		</div>
		<liveShop ref="liveShop"></liveShop>
	</div>
</template>
<script>
import liveShop from './liveShop.vue';
export default {
	props: {
		detailObj: {
			type: Object,
			default: () => {},
		},
		detail_list: {
			type: Array,
			default: () => [],
		},
		ind: {
			type: Number,
			default: () => 0,
		},
	},
	computed: {
		anchor_info() {
			const { detailObj } = this;
			return detailObj && detailObj.anchor_info ? detailObj.anchor_info : {};
		},
		product_list() {
			const { detailObj } = this;
			return detailObj && detailObj.product_list ? detailObj.product_list : [];
		},
	},
	components: {
		liveShop,
	},
	data() {
		return {
			avatarUrl: '',
		};
	},
	methods: {
		lookShop() {
			const { product_list, anchor_info, detail_list, ind } = this;
			this.$refs.liveShop.show(product_list, anchor_info, detail_list, ind);
		},
	},
};
</script>
<style lang="less" scoped>
.info {
	border: 1px solid fadeout(@color-primary, 90%);
	background-color: fadeout(@color-primary, 98%);
	padding: 10px 12px;
	width: 234px;
}
.right-icon {
	font-size: 12px;
}
.clockshijian {
	font-size: 14px;
}
.details-line {
	//margin: 16px 0px;
	height: 32px;
	width: 1px;
	left: 20px;
	top: 28px;
	border-left: 1px dashed #c9cdd4;
	//width: 100%;
	//background-color: #eee;
}
//.time-left {
//	p {
//		height: 20px;
//		overflow: hidden;
//	}
//}
</style>
